import { AddBox } from "@mui/icons-material";
import dayjs from '../../../utils/dayjs-setup';
import { Button, Chip, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,DatePickerInputWithLabel,InputWithLabel, SelectInputWithLabel } from "../../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../../store/AppStore";
import { AxiosInstance, DateFormatString, FormActions, GetStatusAlert, GetStatusIngreso, usuarioEntity } from "../../../utils/constants";
import * as yup from "yup";
import { FilterForm } from "../../../components/form/filter-form";
import { useNavigate } from "react-router-dom";





const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  fecha_entrega:null,
  cod_erp_ocm:null,
  proveedor_select:null,
  ind_estado:"TODAS"
};
const schemaFilter = yup.object({
  

}).required();
export const ReciboListadoOrdenes = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch} = useContext( AppContext );
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const navigate = useNavigate();

  useEffect(()=>{
loadInitData();
  },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
  
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
   



    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }
      console.log({filterSearchPagination});
     let {data:{value}} = await AxiosInstance.post("maestros/listar-ordenes-recibo",{
      ...filterSearchPagination,
      fecha_entrega:dayjs(filterSearchPagination.fecha_entrega).isValid()?filterSearchPagination.fecha_entrega:null,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data]);
     console.log(value.data);
     setTotalRows(value?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const  setFilterAply = (filtros)=>{
      console.log({filtros});
  
      setFilterSearchPagination({
        ...filterSearchPagination,
        ...filtros
      });
    }

    const goToDarIngreso = (info_prod)=>{
       const  base64 =  btoa(`${info_prod.cod}_${info_prod.cod_erp}`);
       navigate(`/plataforma/recibo/${base64}`);
    }


    const onSearchProveedor = async (evt,value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }


    const InputFilters = [
      {
        grid:{
          xs:3,
          md:2,
          sm:6
        },
        InputComponent:DatePickerInputWithLabel,
        keyValue:"fecha_entrega",
        inputProps:{
          size:'small',
        },
        InputComponentProps:{
          label:"Fecha de entrega",
           fullWidth:true,
          isLoading:false,
        
          value:null,
          size:'small',
          //onInputChange:searchMunicipiosOrigen,
         
        }
      },
      {
        grid:{
          xs:6,
          md:2,
          sm:6
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"proveedor_select",
        InputComponentProps:{
          label:"Proveedor",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      }, 
      {
        grid:{
          xs:6,
          md:2,
          sm:6
        },
        InputComponent:SelectInputWithLabel,
        keyValue:"ind_estado",
        InputComponentProps:{
          label:"Estado de la ocm",
          fullWidth: true,
          size:'small',
          items:["TODAS","SIN INGRESO","BORRADOR","ANULADO","TRANSMITIDA"].map(item=>({label:item,value:item}) )
       }
      }, 
      {
        grid:{
          xs:6,
          md:2,
          sm:6
        },
        InputComponent:InputWithLabel,
        keyValue:"cod_erp_ocm",
        InputComponentProps:{
          label:"Codigo ERP OCM",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
          onInputChange: onSearchProveedor,
          options: proveedorOptions || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      }, 

      ];
  
    const columnsTable = [
      {
      
        key:"cod",
        keyValue:"cod",
        label:"ID",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
      
       key:"cod",
       keyValue:"cod_erp",
       label:"Codigo erp",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"proveedor",
        keyValue:"proveedor",
        label:"Proveedor",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_comprador",
        keyValue:"nombre_comprador",
        label:"Comprador",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"centro_operacion",
        keyValue:"centro_operacion",
        label:"Centro de operacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_entrega",
        keyValue:"fecha_entrega",
        label:"F. de entrega",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     {
      
        key:"ingreso_estado",
        keyValue:"ingreso_estado",
        label:"Estado del ingreso",
        headerRender:(props)=>props.label,
        bodyRender:(props)=><Chip color={GetStatusAlert( props.value )} label={props.value?GetStatusIngreso[props.value]:'Sin ingreso'} />,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
      {
        key:"cod_erp",
        keyValue:"cod_erp",
        label:"Ir ",
        headerRender:(props)=>props.label,
        bodyRender:({value,info})=><Button size="small" onClick={e=>goToDarIngreso(info)} variant="contained" startIcon={<AddBox/>} >Dar ingreso</Button>,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
    ];


    return (<>

    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={12} >

        <FilterForm
            buttomDist={
              {
                sx:10,
                md:5
              }
            }
            nameFilter={"Buscar orden  por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            { ...filterSearchPagination
            
             }
            }
            onApplyFilter={setFilterAply}
          />
       
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
         <Typography variant="h6" >
              Listado de ordenes de compra
         </Typography>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}